import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["weightIn", "weightInUnit", "warning"];
  static values = { previousWeightOut: Number, previousUnit: String, template: String };
  static UNIT_TO_GRAMS = {
    g: 1,
    kg: 1000,
    lb: 453.59237,
    oz: 28.349523125,
  };

  check() {
    const previousWeightOut = this.previousWeightOutValue;
    const currentWeightIn = parseFloat(this.weightInTarget.value);
    const unit = this.hasWeightInUnitTarget
      ? this.weightInUnitTarget.value
      : this.previousUnitValue || "kg";
    const previousUnit = this.previousUnitValue || unit;

    if (!previousWeightOut || !currentWeightIn || isNaN(previousWeightOut)) {
      this.warningTarget.classList.add("hidden");
      return;
    }

    const previousWeightInCurrentUnit = this.convertWeightUnit(
      previousWeightOut,
      previousUnit,
      unit,
    );
    if (previousWeightInCurrentUnit === null) {
      this.warningTarget.classList.add("hidden");
      return;
    }

    const diff = Math.abs(currentWeightIn - previousWeightInCurrentUnit);
    if (diff > 0.01) {
      const template = this.hasTemplateValue
        ? this.templateValue
        : "Weight in differs from previous step's output by %{difference} %{unit}";
      const message = template
        .replace("%{difference}", diff.toFixed(2))
        .replace("%{unit}", unit);

      this.warningTarget.textContent = message;
      this.warningTarget.classList.remove("hidden");
    } else {
      this.warningTarget.classList.add("hidden");
    }
  }

  convertWeightUnit(weightValue, fromUnit, toUnit) {
    const fromFactor = this.constructor.UNIT_TO_GRAMS[fromUnit];
    const toFactor = this.constructor.UNIT_TO_GRAMS[toUnit];
    if (!fromFactor || !toFactor) {
      return null;
    }

    const weightValueInGrams = weightValue * fromFactor;
    return weightValueInGrams / toFactor;
  }
}
